import ExcelJS from 'exceljs';
export const exportReservationExcel = (filteredReservation) => {
    const toExcelDate = (date) => {
        if (!(date instanceof Date)) return null;
        const excelEpoch = new Date(Date.UTC(1899, 11, 30)); 
        return Math.floor((date - excelEpoch) / (1000 * 60 * 60 * 24));
    };
    const exportData = filteredReservation.flatMap((reservation) =>
        reservation.clients.map((client) => {
            const تاريخ_الخروج = toExcelDate(new Date(client.checkOutDate)); 
            const تاريخ_الدخول = toExcelDate(new Date(client.checkInDate)); 
            const اسم_العميل = client.clientName;
            const جواز_السفر = client.passport;
            const BC_المرجع = client.BCReference;
            const حالة_الحجز = client.reservationStatus;
            const معرف_الحجز = reservation.id;
            const الغرفة = reservation.selectedRoom;
            const النزل = reservation.selectedHotel;
            const المؤسسة = reservation.selectedorganisme;
            const ملاحظات = reservation.observations;
            const التاريخ = toExcelDate(new Date(reservation.currentDate)); 
            return {
                تاريخ_الخروج,
                تاريخ_الدخول,
                اسم_العميل,
                جواز_السفر,
                BC_المرجع,
                حالة_الحجز,
                معرف_الحجز,
                الغرفة,
                النزل,
                المؤسسة,
                ملاحظات,
                التاريخ,
            };
        })
    );
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("قائمة الحجز");
    worksheet.eachRow((row, rowIndex) => {
        row.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' } };
            cell.border = {};
        });
    });
    worksheet.addRow([
        "تاريخ_الخروج", "تاريخ_الدخول", "اسم_العميل", "جواز_السفر", "BC_المرجع",
        "حالة_الحجز", "معرف_الحجز", "الغرفة", "النزل", "المؤسسة", "ملاحظات", "التاريخ"
    ]);
    exportData.forEach((rowData) => {
        worksheet.addRow([
            rowData.تاريخ_الخروج, rowData.تاريخ_الدخول, rowData.اسم_العميل, rowData.جواز_السفر,
            rowData.BC_المرجع, rowData.حالة_الحجز, rowData.معرف_الحجز, rowData.الغرفة,
            rowData.النزل, rowData.المؤسسة, rowData.ملاحظات, rowData.التاريخ
        ]);
    });
    worksheet.eachRow((row, rowIndex) => {
        row.eachCell((cell, colIndex) => {
            if (colIndex === 1 || colIndex === 2 || colIndex === 12) {
                cell.numFmt = 'DD/MM/YYYY'; 
            }
        });
    });
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } }; 
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4F81BD' } }; 
    });
    const restRow = worksheet.getRow(4);
    restRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: '252525' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffffff' } };
    });
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'قائمة الحجز.xlsx';
        link.click();
    });
};
